(function () {
	'use strict';

	angular.module('qbePortal').controller('QBSmartLink', QBSmartLink);

	QBSmartLink.$inject = ['$scope', '$window', '$rootScope'];

	function QBSmartLink($scope, $window, $rootScope) {
		var vm = this;

		if ($window.qbe.fieldLabels != undefined) {
			$scope.contentData = $window.qbe.fieldLabels.smartLink;
		}

		vm.header = $scope.contentData.header;
		vm.content = $scope.contentData.content;
		vm.star = $scope.contentData.feefoStar;
		vm.feedbackButton = $scope.contentData.feedbackButton;
		vm.feefoLogo = $scope.contentData.feefoLogo;

		vm.submitFeedback = function () {
			$rootScope.$broadcast('submit-feedback');
		}
	}

	angular.module('qbePortal').directive('qbSmartLink',
		function ($window) {
			return {
				templateUrl: '../ngviews/directives/qbSmartLink.html',
				restrict: 'E',
				controller: QBSmartLink,
				controllerAs: 'vm',
				link: function (scope, element) {

					//Repeat by defined number of times
					scope.starCount = function (count) {
						return new Array(count);
					}

					if ($window.innerWidth > 767) {
						setFeefoPosition();
					} else {
						scope.feefoStyle = {
							"position": "relative",
							"top": "0px"
						};
					}

					//Feefo container position
					angular.element($window).bind('resize', function () {
						if ($window.innerWidth > 767) {
							setFeefoPosition();
						} else {
							scope.feefoStyle = {
								"position": "relative",
								"top": "0px"
							};
						}
						scope.$apply();
					});

					function setFeefoPosition() {
						var receiptPosition = document.querySelector('.form-group__container').offsetTop;
						var feefoNewPosition = receiptPosition - 30 + 'px';

						scope.feefoStyle = {
							"position": "relative",
							"top": feefoNewPosition
						};
					}
				}
			};
		});

})();
